export const InjectChannelType = Symbol("InjectChannelType");

export enum IMChannelType {
  whatsapp = "whatsapp",
  iMessage = "iMessage",
  tuvisMessaging = "tuvisMessaging",
  telegram = "telegram",
}
